export const SITE_TITLE = 'Right-Click → View Page Source';
